export default __webpack_public_path__ + "static/media/community-image-1.24b79205.jpg";